import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { includes } from 'lodash/fp';
import ReactGA from 'react-ga';
import * as Sentry from '@sentry/browser';
import { GA_TRACKING_ID } from './constants';
import { getMessageLocale } from './utils';
import App from './modules/app';
import initFirebase from './firebase';

const initIntl = async () => {
  const locale = getMessageLocale({ locale: navigator.language, preserved: ['zh'] });
  const translation = includes(locale, ['en', 'ko', 'ja', 'zh-CN', 'zh-TW'])
    ? await import(`./translations/${locale}.json`)
    : await import('./translations/en.json');

  return translation.default;
};

const initSentry = () => {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: 'school-newsletter',
    debug: process.env.NODE_ENV !== 'production',
    environment: process.env.REACT_APP_STAGE,
  });
};

const init = async () => {
  initSentry();

  initFirebase();

  const translation = await initIntl();

  ReactDOM.render((
    <Router>
      <App translation={translation} />
    </Router>
  ), document.getElementById('root'));
};

init();

ReactGA.initialize(GA_TRACKING_ID);
